const baseURL = process.env.REACT_APP_LAYTRADER_BASE_URL


export const get_account = async (accessToken) => {
    try {
        const response = await fetch(`${baseURL}/account/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const get_configure = async (accessToken) => {
    try {
        const response = await fetch(`${baseURL}/account/configure/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const configure = async ({ accessToken, auth_cont, url }) => {
    try {
        ;
        const requestBody = JSON.stringify({
            "auth_context": auth_cont,
            "url": url
        });
        const response = await fetch(`${baseURL}/account/configure/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: requestBody
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const account_view = async (accessToken, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const account_delete = async (accessToken, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


export const post_watchlist = async (accessToken, watchlist, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/watchlist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({ "watchlist": watchlist, "accountNumber": accountNumber })
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


export const get_models = async (accessToken) => {
    try {
        const response = await fetch(`${baseURL}/trader/models/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


export const tickers = async (accessToken) => {
    try {
        const response = await fetch(`${baseURL}/trader/tickers/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const run_trader = async (accessToken, model, accountNumber, minimum) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/trade/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({ "model": model, "minimumValue": +minimum })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const get_jobs = async (accessToken, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/trade/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const clear_job = async (accessToken, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/trade/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({ "accountNumber": accountNumber })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


export const candles = async (accessToken, tickers, accountNumber) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/candles/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({ "tickers": tickers, "accountNumber": accountNumber })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const get_data = async (accessToken, accountNumber, tickers) => {
    try {
        const response = await fetch(`${baseURL}/account/${accountNumber}/data/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({ "tickers": tickers })
        })
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
